export const templateMenuTranslations: Record<string, string> = {
  socialUpdates: $localize`:@@movie-template-a.menu.socialUpdates:Social updates`,
  videos: $localize`:@@movie-template-a.menu.videos:Videos`,
  posters: $localize`:@@movie-template-a.menu.posters:Posters`,
  signUp: $localize`:@@movie-template-a.menu.signUp:Sign up`,
  watchTrailer: $localize`:@@movie-template-a.menu.watchTrailer:Watch trailer`,
  contact: $localize`:@@movie-template-a.menu.contact:Contact`,
  gallery: $localize`:@@movie-template-a.menu.gallery:Gallery`,
  watchAtHome: $localize`:@@movie-template-a.menu.watchAtHome:Watch at home`,
  learnMore: $localize`:@@movie-template-a.menu.learnMore:Learn More`,
  synopsisAndCast: $localize`:@@movie-template-a.menu.synopsisAndCast:Synopsis & Cast`,
  noImages: $localize`:@@movie-template-a.noImages:No images`,
  inCinemas: $localize`:@@movie-template-a.menu.inCinemas:Book tickets`,
  watchNow: $localize`:@@movie-template-a.menu.watchNow:Watch feature`,
  competitions: $localize`:@@movie-template-a.menu.competitions:Competitions`
};
